import { Component, EventEmitter, Output } from '@angular/core';
import { Severity, SnackbarMessage } from '../../../model/snackbar';

@Component({
  selector: 'app-snack-bar',
  template: `
    <div class="snackBar-wrapper">
      <div *ngFor="let toast of toasts" [ngClass]="getClass(toast.severity)" class="snackBar">
        <div class="toast-content">
          <div class="toast-text"> 
            <span *ngIf="toast.title">{{ toast.title }}</span>
          </div>
          <button class="close-btn" (click)="removeToast(toast)">×</button>
        </div>
        <div class="progress-bar" [style.width.%]="toast.progress"></div>
      </div>
    </div>
  `,
  styles: [`
    .snackBar-wrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;
      pointer-events: none;
    }
    .snackBar {
      padding: 12px 16px;
      border-radius: 8px;
      min-width: 250px;
      color: white;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      display: flex;
      flex-direction: column;
      pointer-events: auto;
      overflow: hidden;
      opacity: 0.95;
      transition: transform 0.3s ease, opacity 0.3s ease;
    }
    .toast-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .toast-text { flex: 1; white-space: pre-line; font-weight: 400;}
    .close-btn {
      background: transparent;
      border: none;
      color: white;
      font-size: 18px;
      cursor: pointer;
      margin-left: 8px;
    }
    .progress-bar {
      height: 4px;
      background-color: rgba(255,255,255,0.7);
      margin-top: 8px;
      transition: width linear;
    }
  `],
  standalone: false
})
export class SnackBarComponent {
  @Output() onAllToastsClosed = new EventEmitter<void>();

  toasts: SnackbarMessage[] = [];

  showToast(message: SnackbarMessage, duration = 4000) {
    message.progress = 100;
    this.toasts.push(message);

    const intervalTime = duration / 100;
    const interval = setInterval(() => {
      message.progress -= 1;
      if (message.progress <= 0) {
        clearInterval(interval);
        this.removeToast(message);
      }
    }, intervalTime);
  }

  removeToast(message: SnackbarMessage) {
    this.toasts = this.toasts.filter(t => t !== message);
    if (this.toasts.length === 0) {
      this.onAllToastsClosed.emit();
    }
  }

  getClass(severity: Severity): string {
    const classMap: Record<Severity, string> = {
      [Severity.SUCCESS]: 'snackBar success',
      [Severity.ERROR]: 'snackBar error',
      [Severity.WARNING]: 'snackBar warning',
      [Severity.INFO]: 'snackBar info',
    };
    return classMap[severity] || 'snackBar info';
  }
}
